import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';


export const INITIAL_STATE = Immutable({
    alerts: {

    }
});

const storeAlerts = (state, action) => {
    return state.merge({
        alerts: {...state.alerts, [action.response.queue]: {...action.response.response}}
    });
};

const ACTION_HANDLERS = {
    [Types.STORE_ALERTS]: storeAlerts
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)


// WEBPACK FOOTER //
// ./src/Reducers/UserReducer.js